import React, { useEffect, useState } from 'react';

import { PlusIcon } from '@vlabs/icons';
import { Control } from '@vlabs/uikit';
import { useFieldArray, useWatch, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { CustomFilterPopover } from '../components/CustomFilterPopover';
import { hasMetaErrors } from '../helpers';
import { useFilterCount } from '../hooks';
import st from '../shared.module.sass';
import { MetaFilter } from './meta-filter/MetaFilter';

const defaultMeta = {
  key: '',
  type: undefined,
  operator: undefined,
  value: '',
};

export function MetaPopover({ onCountChange = undefined }) {
  const { t } = useTranslation();
  const { formState: { errors } } = useFormContext();
  const { fields, append, remove } = useFieldArray({ name: 'meta' });
  const metaFields = useWatch({ name: 'meta' });

  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    setHasError(hasMetaErrors(errors));
  }, [errors, errors.meta]);

  // надо будет в будущем изменить фильтр - по дефолту показывать один
  // const didInitialize = useRef(false);

  // useEffect(() => {
  //   if (!didInitialize.current && (!metaFields || metaFields.length === 0)) {
  //     append(defaultMeta);
  //     didInitialize.current = true;
  //   }
  // }, [append, metaFields]);

  const isFilled = (filter) => filter.key
    && filter.value
    && filter.type
    && filter.operator;
  const filterCount = metaFields?.filter(isFilled).length > 0 ? 1 : 0;
  useFilterCount('meta', filterCount, onCountChange);

  const handleAppend = () => {
    append({ ...defaultMeta });
  };

  const handleRemove = (index) => {
    remove(index);
  };
  return (
    <CustomFilterPopover
      className={st.wrapper_scrollable}
      hasError={hasError}
      hasFilterValue={Boolean(filterCount)}
      testId="metaFilter"
      triggerValue={t('events:фильтр по meta')}
    >
      {fields.map((field, i) => (
        <MetaFilter
          i={i}
          key={field.id}
          remove={handleRemove}
        />
      ))}

      <Control.Button
        data-testid="meta.plusIcon"
        icon={<PlusIcon />}
        kind="primary"
        onClick={handleAppend}
        title={t('кнопка.добавить')}
        variant="flat"
      >
        {t('events:добавить фильтр')}
      </Control.Button>
    </CustomFilterPopover>
  );
}
